import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from '../../../common/Link';
import { MODAL_LIST_ITEMS } from './constants';
import * as styles from './ModalContent.css';

export const ModalContent = () => (
  <ul className={styles['list']}>
    {MODAL_LIST_ITEMS.map(item => (
      <li key={item} className={styles['list-item']}>
        <UIText1>{item}</UIText1>
      </li>
    ))}
    <li className={styles['list-item']}>
      <UIText1>
        на{' '}
        {
          <Link
            href="https://lk.rosreestr.ru/eservices/real-estate-objects-online"
            target="_blank"
            rel="nofollow noopener noreferrer"
            title="сайт Росреестра"
          >
            сайте Росреестра
          </Link>
        }{' '}
        по адресу участка.
      </UIText1>
    </li>
  </ul>
);
